module.exports = __webpack_public_path__ + "img/cloud-hail-sun.c7998230.svg";